var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTvTerminal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9444 25.1437H7.97222V12.5723H0V4.57227H15.9444V25.1437ZM31.8889 25.1437H22.7778L31.3194 4.57227H40.4306L31.8889 25.1437Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7777 13.7151C25.2937 13.7151 27.3333 11.6684 27.3333 9.14369C27.3333 6.61896 25.2937 4.57227 22.7777 4.57227C20.2618 4.57227 18.2222 6.61896 18.2222 9.14369C18.2222 11.6684 20.2618 13.7151 22.7777 13.7151Z",
    fill: "#1E293B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvTerminal);
export default __webpack_public_path__ + "static/media/tv_terminal.d3510a9dd7b6d5b143aa8356545e201b.svg";
export { ForwardRef as ReactComponent };